module.exports = __webpack_public_path__ + "img/lost.bd67a8ff.png";